import React, { useState } from "react";
import "./InquiryBox.css";

export default function InquiryBox() {
  const [loading, setLoading] = useState(false);

  function validateForm(formData) {
    const name = formData.get("FullName").trim();
    const phone = formData.get("Phone").trim();
    const course = formData.get("Course").trim();

    // Full name validation (only letters and spaces, min 3 chars)
    const nameRegex = /^[A-Za-z\s]{3,}$/;
    if (!nameRegex.test(name)) {
      alert("Please enter a valid full name (at least 3 letters).");
      return false;
    }

    // Phone validation (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      alert("Please enter a valid 10-digit phone number.");
      return false;
    }

    // Course validation (not empty, at least 2 chars)
    if (course.length < 2) {
      alert("Please enter a valid course name.");
      return false;
    }

    return true;
  }

  function Submit(e) {
    e.preventDefault();
    setLoading(true);

    const formEle = e.target;
    const formData = new FormData(formEle);

    // Run validation before sending
    if (!validateForm(formData)) {
      setLoading(false);
      return;
    }

    fetch(
      "https://script.google.com/macros/s/AKfycbx6IiE130PDq2nsFQdTgHNGGksfYysguDz4QSe7RWigqU7bcV4CH0zr7kZgZn9rPSEA/exec",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Success:", data);
        alert("Enquiry submitted successfully!");
        formEle.reset();
      })
      .catch((error) => {
        console.error("❌ Error:", error);
        alert("Failed to submit enquiry.");
      })
      .finally(() => setLoading(false));
  }

  return (
    <div className="inquiry-box">
      <h2 className="inquiry-heading">Inquiry Box</h2>
      <form onSubmit={Submit} className="inquiry-form">
        <input type="text" name="FullName" placeholder="Full Name" required />
        <input type="tel" name="Phone" placeholder="Phone Number" required />
        <input type="text" name="Course" placeholder="Course Name" required />

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
}
